export class ArtikelNote {
  id: number;
  note: string;
  artikelstamm: string;
  artnr: number;
  kunde_nr: string;
}
